var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"logo_home"}},[_c('h1',[_c('router-link',{style:('background-image: url('+ _vm.appImage +');'),attrs:{"to":{ name: 'home' },"title":_vm.appName}},[_vm._v(_vm._s(_vm.appName))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }